module.exports = __webpack_public_path__ + "media/images/lp_consultation/importance-reason02-d270159ac22b5faf0bda1ddc1d2a8a65.jpg";